import emptyFunction from 'react-utils/emptyFunction';
import { createAction } from 'automation-ui-core/ambient-types/flux-actions';
import createRequestTypes from 'automation-ui-canvas/actions/utils/createRequestTypes';
import simpleApiRequest from 'automation-ui-canvas/actions/utils/simpleApiRequest';
import * as AlertTypes from 'automation-ui-canvas/constants/AlertTypes';
import * as ActionTypes from 'automation-ui-canvas/actions/ActionTypes';
import * as messageActions from 'automation-ui-canvas/actions/MessageActions';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import * as EarlyRequesterRequestNames from 'automation-ui-canvas/constants/EarlyRequesterRequestNames';
import * as FlowsApi from 'automation-ui-canvas/data/api/FlowsApi';
import { addAlert } from 'automation-ui-canvas/actions/MessageActions';
export const FlowActionTypes = {
  ADD_USER_EDITED_ACTION_IDS: 'ADD_USER_EDITED_ACTION_IDS',
  BULK_ENROLL_BY_LIST_ID: 'BULK_ENROLL_BY_LIST_ID',
  BULK_ENROLL_BY_DATASET_ID: 'BULK_ENROLL_BY_DATASET_ID',
  CLEAR_WORKFLOW_AUDIT_EVENT_HISTORY: 'CLEAR_WORKFLOW_AUDIT_EVENT_HISTORY',
  CREATE_BULK_ENROLLMENT: 'CREATE_BULK_ENROLLMENT',
  FETCH_ACTIVE_OBJECTS: 'FETCH_ACTIVE_OBJECTS',
  FETCH_EMAIL_GOAL_COUNTS: 'FETCH_EMAIL_GOAL_COUNTS',
  FETCH_FLOW_REVISION: 'FETCH_FLOW_REVISION',
  FETCH_FLOW_REVISIONS: 'FETCH_FLOW_REVISIONS',
  FETCH_FLOW_VALIDATION_OBJECT: 'FETCH_FLOW_VALIDATION_OBJECT',
  FETCH_FLOW_VALIDATION: 'FETCH_FLOW_VALIDATION',
  FETCH_HYBRID_EMAIL_CAMPAIGNS: 'FETCH_HYBRID_EMAIL_CAMPAIGNS',
  FETCH_HYBRID_FLOW_PERFORMANCE_LIST_COUNTS: 'FETCH_HYBRID_FLOW_PERFORMANCE_LIST_COUNTS',
  SIMULATE_FLOW: 'SIMULATE_FLOW',
  SIMULATE_HYBRID_FLOW: 'SIMULATE_HYBRID_FLOW',
  SIMULATE_FLOW_DYNAMIC_LOG_EVENTS: 'SIMULATE_FLOW_DYNAMIC_LOG_EVENTS',
  UPDATE_WORKFLOW_AUDIT_EVENT_HISTORY: 'UPDATE_WORKFLOW_AUDIT_EVENT_HISTORY'
};

// Non-api actions
// ----- ----- ----- ----- -----
export const BulkEnrollByListIdActionTypes = createRequestTypes(FlowActionTypes.BULK_ENROLL_BY_LIST_ID, {
  once: false
});
export const BulkEnrollByDatasetIdActionTypes = createRequestTypes(FlowActionTypes.BULK_ENROLL_BY_DATASET_ID, {
  once: false
});
export const FetchFlowRevisionActionTypes = createRequestTypes(FlowActionTypes.FETCH_FLOW_REVISION, {
  once: false
});
export const SimulateFlowActionTypes = createRequestTypes(FlowActionTypes.SIMULATE_FLOW, {
  once: false
});
export const SimulateFlowDynamicLogEventsActionTypes = createRequestTypes(FlowActionTypes.SIMULATE_FLOW_DYNAMIC_LOG_EVENTS, {
  once: false
});
export const CreateBulkEnrollmentActionTypes = createRequestTypes(FlowActionTypes.CREATE_BULK_ENROLLMENT, {
  once: false
});
export const FetchHybridFlowPerformanceListCounts = createRequestTypes(FlowActionTypes.FETCH_HYBRID_FLOW_PERFORMANCE_LIST_COUNTS, {
  once: false
});
export const FetchHybridEmailCampaigns = createRequestTypes(FlowActionTypes.FETCH_HYBRID_EMAIL_CAMPAIGNS, {
  once: false
});
export const FetchEmailGoalCounts = createRequestTypes(FlowActionTypes.FETCH_EMAIL_GOAL_COUNTS, {
  once: false
});
export const FetchFlowValidationTypes = createRequestTypes(FlowActionTypes.FETCH_FLOW_VALIDATION, {
  once: false
});
export const FetchFlowValidationObjectTypes = createRequestTypes(FlowActionTypes.FETCH_FLOW_VALIDATION_OBJECT, {
  once: false
});
export const bulkEnrollByListId = simpleApiRequest(FlowsApi.createBulkEnrollmentByListId, BulkEnrollByListIdActionTypes);
export const requestFlowRevision = simpleApiRequest(FlowsApi.getFlowRevisionById, FetchFlowRevisionActionTypes);
export const requestFlowValidation = simpleApiRequest(FlowsApi.validateFlow, FetchFlowValidationTypes, EarlyRequesterRequestNames.FLOW_VALIDATION);

/**
 * Use the same early request key as the GET
 * version of validation because there will
 * never be local changes on initial render.
 */
export const requestFlowValidationObject = simpleApiRequest(FlowsApi.validateFlowObject, FetchFlowValidationObjectTypes, EarlyRequesterRequestNames.FLOW_VALIDATION);
export const requestHybridPerformanceListCounts = simpleApiRequest(FlowsApi.getHybridFlowPerformanceListCounts, FetchHybridFlowPerformanceListCounts);
export const updateActionFailed = () => dispatch => {
  return dispatch(messageActions.addAlert(AlertTypes.UPDATE_ACTION_FAILED));
};
export const updateFlowLocally = createAction(ActionTypes.UPDATE_FLOW_LOCALLY, flow => ({
  flow
}));
export const addUserEditedActionId = createAction(FlowActionTypes.ADD_USER_EDITED_ACTION_IDS, ({
  flow,
  action
}) => ({
  flow,
  action
}));
export const revertStagedChanges = createAction(ActionTypes.REVERT_STAGED_CHANGES);
export const simulateFlowDynamicLogEvents = simpleApiRequest(FlowsApi.simulateFlowDynamicLogEvents, SimulateFlowDynamicLogEventsActionTypes);
export const createBulkEnrollment = ({
  flowId,
  objectTypeId,
  selectedIds
}, callback, onSuccessCallback) => dispatch => {
  const apiRequest = simpleApiRequest(FlowsApi.createBulkEnrollment, CreateBulkEnrollmentActionTypes);
  void dispatch(apiRequest({
    flowId,
    objectTypeId,
    selectedIds
  }, action => {
    if (callback) {
      callback(action);
    }
    if (action.type === CreateBulkEnrollmentActionTypes.SUCCEEDED) {
      onSuccessCallback(action.payload.response);
    } else if (action.type === CreateBulkEnrollmentActionTypes.FAILED) {
      dispatch(addAlert(AlertTypes.DEFAULT));
    }
  }));
};
export const createBulkEnrollmentByListId = ({
  flowId,
  listId
}, callback, onSuccessCallback) => dispatch => {
  const apiRequest = simpleApiRequest(FlowsApi.createBulkEnrollmentByListId, BulkEnrollByListIdActionTypes);
  void dispatch(apiRequest({
    flowId,
    listId
  }, action => {
    if (callback) {
      callback(action);
    }
    if (action.type === BulkEnrollByListIdActionTypes.SUCCEEDED) {
      onSuccessCallback();
    } else if (action.type === BulkEnrollByListIdActionTypes.FAILED) {
      dispatch(addAlert(AlertTypes.DEFAULT));
    }
  }));
};
export const createBulkEnrollmentByDatasetId = ({
  flowId,
  datasetId
}, callback, onSuccessCallback) => dispatch => {
  const apiRequest = simpleApiRequest(FlowsApi.createBulkEnrollmentByDatasetId, BulkEnrollByDatasetIdActionTypes);
  void dispatch(apiRequest({
    flowId,
    datasetId
  }, action => {
    if (callback) {
      callback(action);
    }
    if (action.type === BulkEnrollByDatasetIdActionTypes.SUCCEEDED) {
      onSuccessCallback();
    } else if (action.type === BulkEnrollByDatasetIdActionTypes.FAILED) {
      dispatch(addAlert(AlertTypes.DEFAULT));
    }
  }));
};
export function updateActionLocally({
  flow,
  action,
  edgeId,
  callback = emptyFunction
}) {
  let newFlow = flow;
  if (action.isNew()) {
    newFlow = flow.removeAction(SpecialActionIds.NEW_ACTION).insertAction({
      action,
      edgeId
    });
  } else {
    newFlow = flow.replaceAction(action);
  }
  callback({
    payload: {
      flow: newFlow
    }
  });
  return updateFlowLocally(newFlow);
}